import React, { useState, useEffect } from 'react';
import { 
  Button, Table, Card, Badge, 
  Pagination, Spinner 
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { listCampaigns } from '../../services/api';

const CampaignListPage = () => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  
  const PAGE_SIZE = 10;
  
  useEffect(() => {
    const fetchCampaigns = async () => {
      setLoading(true);
      try {
        const data = await listCampaigns({
          skip: (page - 1) * PAGE_SIZE,
          limit: PAGE_SIZE
        });
        console.log('Campaigns data received:', data.campaigns);
        setCampaigns(data.campaigns);
        setTotalPages(Math.ceil(data.total / PAGE_SIZE));
      } catch (err) {
        console.error('Error fetching campaigns:', err);
        setError('Failed to load campaigns. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchCampaigns();
  }, [page]);
  
  const renderStatus = (status) => {
    if (status === 'active') {
      return <Badge bg="success">Active</Badge>;
    } else if (status === 'inactive') {
      return <Badge bg="secondary">Inactive</Badge>;
    } else if (status === 'completed') {
      return <Badge bg="primary">Completed</Badge>;
    }
    return <Badge bg="secondary">{status}</Badge>;
  };
  
  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleString();
  };
  
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2>Campaigns</h2>
          <p className="text-muted mb-0">
            Manage your campaign targeting and lead generation
          </p>
        </div>
        <div className="d-flex gap-2">
          <Link to="/campaigns/new">
            <Button variant="primary">
              <i className="bi bi-sliders me-2"></i>
              Create Campaign
            </Button>
          </Link>
        </div>
      </div>

      <Card>
        <Card.Body>
          {loading ? (
            <div className="text-center p-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : error ? (
            <div className="text-center p-3 text-danger">{error}</div>
          ) : campaigns.length === 0 ? (
            <div className="text-center p-5">
              <p className="mb-4">No campaigns found.</p>
              <Link to="/campaigns/new">
                <Button variant="primary">Create Campaign</Button>
              </Link>
            </div>
          ) : (
            <>
              <Table responsive hover>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Bank</th>
                    <th>Process</th>
                    <th>Lead Count</th>
                    <th>Created</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {campaigns.map((campaign) => {
                    console.log("Rendering campaign row:", campaign);
                    return (
                      <tr key={campaign.id}>
                        <td>
                          <Link
                            to={`/campaigns/${campaign.id}`}
                            className="text-decoration-none"
                          >
                            {campaign.name}
                          </Link>
                        </td>
                        <td>{campaign.bank}</td>
                        <td>{campaign.process}</td>
                        <td>{campaign.lead_count}</td>
                        <td>{formatDate(campaign.created_at)}</td>
                        <td>{renderStatus(campaign.status)}</td>
                        <td>
                          <Link to={`/campaigns/${campaign.id}`}>
                            <Button variant="outline-primary" size="sm">
                              View
                            </Button>
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>

              {totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                  <Pagination>
                    <Pagination.First
                      onClick={() => setPage(1)}
                      disabled={page === 1}
                    />
                    <Pagination.Prev
                      onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                      disabled={page === 1}
                    />

                    {[...Array(totalPages)].map((_, i) => (
                      <Pagination.Item
                        key={i + 1}
                        active={i + 1 === page}
                        onClick={() => setPage(i + 1)}
                      >
                        {i + 1}
                      </Pagination.Item>
                    ))}

                    <Pagination.Next
                      onClick={() =>
                        setPage((prev) => Math.min(prev + 1, totalPages))
                      }
                      disabled={page === totalPages}
                    />
                    <Pagination.Last
                      onClick={() => setPage(totalPages)}
                      disabled={page === totalPages}
                    />
                  </Pagination>
                </div>
              )}
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default CampaignListPage;